class Puzzle {
  constructor() {
    this.$puzzle = document.querySelector('.js-puzzle');

    if(this.$puzzle) {
      this.$dropzone = this.$puzzle.querySelector('.js-puzzle-dropzone');
      this.$draggable = this.$puzzle.querySelector('.js-puzzle-draggable');

      this.audioContext = null;
      this.snapBuffer = null;
      this.snapUrl = null;
      this.init();
    }
  }

  init() {
    gsap.registerPlugin(Draggable);
    this.initDraggable();
  }

  initAudioContext() {
  this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
  // iOS Safari entsperren
  this.audioContext.resume();
}

  async preloadAudio() {
    try {
      const response = await fetch(this.snapUrl);
      const audioData = await response.arrayBuffer();
      this.snapBuffer = await this.audioContext.decodeAudioData(audioData);
    } catch(e) {
      console.log('Audio Fehler:', e);
    }
  }

  playSnapSound() {
    if (!this.snapBuffer || !this.audioContext) return;
    const source = this.audioContext.createBufferSource();
    source.buffer = this.snapBuffer;
    source.connect(this.audioContext.destination);
    source.start(0);
  }

  initDraggable() {
    this.draggable = Draggable.create(this.$draggable, {
      type: 'x,y',
      edgeResistance: 0.65,
      bounds: window,
      zIndex: 10,
      zIndexBoost: false,
      onPress: () => {
  this.$draggable.classList.add('puzzle__draggable--dragging');
  if (!this.audioContext) {
    this.initAudioContext();
    // iOS Safari entsperren mit leerem Buffer
    const buffer = this.audioContext.createBuffer(1, 1, 22050);
    const source = this.audioContext.createBufferSource();
    source.buffer = buffer;
    source.connect(this.audioContext.destination);
    source.start(0);
    this.snapUrl = window.puzzleSnapUrl;
    this.preloadAudio();
  }
},
      onRelease: () => {
        this.$draggable.classList.remove('puzzle__draggable--dragging');
      },
      onDragEnd: () => {
        this.$draggable.classList.remove('puzzle__draggable--dragging');

        const puzzleRect    = this.$puzzle.getBoundingClientRect();
        const dropzoneRect  = this.$dropzone.getBoundingClientRect();
        const draggableRect = this.$draggable.getBoundingClientRect();

        const targetX  = dropzoneRect.left - puzzleRect.left + (dropzoneRect.width  - draggableRect.width)  / 2;
        const targetY  = dropzoneRect.top  - puzzleRect.top  + (dropzoneRect.height - draggableRect.height) / 2;
        const currentX = draggableRect.left - puzzleRect.left;
        const currentY = draggableRect.top  - puzzleRect.top;

        const distanceX = targetX - currentX;
        const distanceY = targetY - currentY;
        const distance  = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

        if (distance <= (dropzoneRect.width * 1.5)) {
          this.$draggable.classList.add('puzzle__draggable--snapped');
          gsap.to(this.$draggable, {
            x: this.draggable[0].x + distanceX,
            y: this.draggable[0].y + distanceY,
            rotation: 0,
            duration: 0.15,
            ease: 'power2.out',
            onComplete: () => {
              this.playSnapSound();
            }
          });
        } else {
          this.$draggable.classList.remove('puzzle__draggable--snapped');
        }
      }
    });

    gsap.set(this.$draggable, { x: 0, y: 0, clearProps: 'right' });
  }
}

const puzzle = new Puzzle();